export default __webpack_public_path__ + "static/media/meal5.302351ea.svg";